import React, { Fragment, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import Sidebar from '../../layout/Sidebar'
import { getUpcomingAppointments } from '../../../actions/upcoming_appointments'
import { getPastAppointments } from "../../../actions/past_appointments"
import { getAllApplications } from "../../../actions/appointments"
// import Spinner from '../../layout/Spinner';
import moment from "moment";
import imgs from '../../../utils/images';
import DataTable from 'react-data-table-component';

import ExpandedComponent from './ExpandedComponent';
import Calendar from '../../../utils/calendar';


const customStyles = {
    header: {
        style: {
            minHeight: '56px',
        },
    },
    headRow: {
        style: {
            borderTopStyle: 'solid',
            borderTopWidth: '1px',
            borderTopColor: '#ECECEC',
            backgroundColor: '#F8F8F8',
            fontWeight: 'bold',

        },
    },
    headCells: {
        style: {

            borderRightStyle: 'solid',
            borderRightWidth: '1px',
            borderRightColor: '#ECECEC',

            '&:nth-of-type(2)': {
                borderLeftStyle: 'solid',
                borderLeftWidth: '1px',
                borderLeftColor: '#ECECEC',
            }
        },
    },
    cells: {
        style: {
            '&:nth-of-type(6)': {
                textTransform: 'uppercase',
                fontWeight: '500'
            },
            borderRightStyle: 'solid',
            borderRightWidth: '1px',
            borderRightColor: '#ECECEC',
            '&:nth-of-type(1)': {
                borderLeftStyle: 'solid',
                borderLeftWidth: '1px',
                borderLeftColor: '#ECECEC',
                color: '#006AFF'
            }
        },
    },
};

const columns = [
    {
        name: 'Booking ID',
        selector: row => 'BID' + row.id,
        sortable: true,
    },
    {
        name: 'Appointment Date',
        selector: row => moment(row.book_date).format('ddd, D MMM YYYY') + ', ' + row.book_time,
        sortable: true,
    },
    {
        name: 'Customer Name',
        selector: row => row.firstName + ' ' + row.lastName,
        sortable: true,
    },
    {
        name: 'Total Amount',
        selector: row => row.amount,
        sortable: true,
    },
    {
        name: 'Payment Status',
        selector: row => row.payment_status,
        sortable: true,
        conditionalCellStyles: [
            {
                when: row => row.payment_status === 'paid',
                style: {
                    color: 'green',
                },
            },
            {
                when: row => row.payment_status === 'unpaid',
                style: {
                    color: 'red',
                },
            },
            {
                when: row => row.payment_status === 'refunded',
                style: {
                    color: '#FEC053',
                },
            },

        ],
    },
];



const AppointmentViews = ({ getAllApplications, getUpcomingAppointments, getPastAppointments, upcoming: { upcoming_appointments }, past: { past_appointments }, appointments: { appointments } }) => {
    const [activeTab, setActiveTab] = useState('upcoming');
    const [activeView, setActiveView] = useState('table');

    const rowPreExpanded = row => row.defaultExpanded;

    useEffect(() => {
        getUpcomingAppointments();
    }, [getUpcomingAppointments]);

    useEffect(() => {
        getPastAppointments();
    }, [getPastAppointments]);

    useEffect(() => {
        getAllApplications();
    }, [getAllApplications])

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };



    const handleViewClick = (tab) => {
        setActiveView(tab);
    };

    return (
        <Fragment>
            <div className='wrapper'>
                <Sidebar />
                <div className='servicePage'>
                    <div className='serviceHeader'>
                        <div className='d-flex justify-content-between p-3'>
                            <h2 className='fw-400'>Appointments</h2>
                        </div>
                    </div>
                    <section className="px-2 py-5" id="dashboard_analysis">
                        <div className="container">
                            <div className="d-flex justify-content-between">

                                {activeView === "table" && <ul className='btn-group mb-3' role="group" aria-label="First group">
                                    <li className={`btn btn-outline-secondary btn-sm  ${activeTab === 'upcoming' ? 'active' : ''}`} onClick={() => handleTabClick('upcoming')}>Upcoming</li>
                                    <li className={`btn btn-outline-secondary btn-sm  ${activeTab === 'past' ? 'active' : ''}`} onClick={() => handleTabClick('past')}>Completed</li>
                                    {/* <li className={`btn btn-outline-secondary btn-sm ${activeTab === 'cancelled' ? 'active' : ''}`} onClick={() => handleTabClick('cancelled')}>Cancelled</li> */}
                                </ul>}
                                <div></div>
                                <ul className='btn-group mb-3' role="group" aria-label="First group">
                                    <li className={`btn btn-outline-secondary lh-1 ${activeView === 'table' ? 'active' : ''}`} onClick={() => handleViewClick('table')}> <img src={imgs.table} alt="table" /> </li>
                                    <li className={`btn btn-outline-secondary lh-1 ${activeView === 'calender' ? 'active' : ''}`} onClick={() => handleViewClick('calender')}><img src={imgs.calendar} alt="calendar" /></li>
                                </ul>
                            </div>
                            <div className="row">
                                {activeView === "table" && <div className="col-12">
                                    {activeTab === 'upcoming' && <div>
                                        <DataTable columns={columns} data={upcoming_appointments} pagination customStyles={customStyles} expandableRows
                                            expandableRowExpanded={rowPreExpanded} expandableRowsComponent={ExpandedComponent}
                                        />
                                    </div>}
                                    {activeTab === 'past' && <div>
                                        <DataTable columns={columns} data={past_appointments} pagination customStyles={customStyles} expandableRows
                                            expandableRowExpanded={rowPreExpanded} expandableRowsComponent={ExpandedComponent}
                                        />
                                    </div>}
                                </div>}
                                {activeView === "calender" && <div className="col-12">
                                    <Calendar data={appointments} />
                                </div>}
                            </div>
                        </div>
                    </section>
                </div>
            </div >
        </Fragment >
    )
}

AppointmentViews.propTypes = {
    getUpcomingAppointments: PropTypes.func.isRequired,
    getPastAppointments: PropTypes.func.isRequired,
    getAllApplications: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
    upcoming: state.upcoming_appointments,
    past: state.past_appointments,
    appointments: state.appointments,
});

export default connect(mapStateToProps, { getUpcomingAppointments, getPastAppointments, getAllApplications })(AppointmentViews)

